import { cn } from '@/lib/utils'

export const AlertAction = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => (
  <div
    data-slot="alert-action"
    className={cn('absolute top-2 right-2', className)}
    {...props}
  />
)
